import RatePlanManagementTemplate from "../../../templates/admin/ratePlanManagement";

const RatePlanManagementScreen = () => {
  return <RatePlanManagementTemplate />;
};

export default RatePlanManagementScreen;
